// import axiosInstance from "../utils/axios";

import axiosInstance from "../utils/axios";

export const getAllPlans = async () => {
  // const res = await axiosInstance.get("/api/product");
  // return res.data;
  const res = {
    data: [
      {
        id: 1,
        version: 0,
        productId: "prod_LNubrEBdM4vJNF",
        priceId: "price_1Kh8lyGf5lNQlEFW7R2xTc9H",
        name: "Base package",
        description: "Base Package for publisher",
        booksUploads: 10,
        booksFulfillments: 100,
        price: "10",
      },
      {
        id: 2,
        version: 0,
        productId: "prod_LNubAxXiO60YJC",
        priceId: "price_1Kh8mbGf5lNQlEFWtRTjJaW7",
        name: "medium package",
        description: "Medium Package for publisher",
        booksUploads: 50,
        booksFulfillments: 400,
        price: "50",
      },
      {
        id: 3,
        version: 0,
        productId: "prod_LNucm3fIGHqyPE",
        priceId: "price_1Kh8n9Gf5lNQlEFWdiApknDQ",
        name: "Premium package",
        description: "Premium Package for publisher",
        booksUploads: 100,
        booksFulfillments: 1000,
        price: "100",
      },
      {
        id: 4,
        version: 0,
        productId: "prod_LNucm3fIGHqyPE",
        priceId: "price_1Kh8n9Gf5lNQlEFWdiApknDQ",
        name: "Premium package",
        description: "Premium Package for publisher",
        booksUploads: 100,
        booksFulfillments: 1000,
        price: "100",
      },
      {
        id: 5,
        version: 0,
        productId: "prod_LNucm3fIGHqyPE",
        priceId: "price_1Kh8n9Gf5lNQlEFWdiApknDQ",
        name: "Premium package",
        description: "Premium Package for publisher",
        booksUploads: 100,
        booksFulfillments: 1000,
        price: "100",
      },
      {
        id: 6,
        version: 0,
        productId: "prod_LNucm3fIGHqyPE",
        priceId: "price_1Kh8n9Gf5lNQlEFWdiApknDQ",
        name: "Premium package",
        description: "Premium Package for publisher",
        booksUploads: 100,
        booksFulfillments: 1000,
        price: "100",
      },
      {
        id: 7,
        version: 0,
        productId: "prod_LNucm3fIGHqyPE",
        priceId: "price_1Kh8n9Gf5lNQlEFWdiApknDQ",
        name: "Premium package",
        description: "Premium Package for publisher",
        booksUploads: 100,
        booksFulfillments: 1000,
        price: "100",
      },
      {
        id: 8,
        version: 0,
        productId: "prod_LNucm3fIGHqyPE",
        priceId: "price_1Kh8n9Gf5lNQlEFWdiApknDQ",
        name: "Premium package",
        description: "Premium Package for publisher",
        booksUploads: 100,
        booksFulfillments: 1000,
        price: "100",
      },
      {
        id: 9,
        version: 0,
        productId: "prod_LNucm3fIGHqyPE",
        priceId: "price_1Kh8n9Gf5lNQlEFWdiApknDQ",
        name: "Premium package",
        description: "Premium Package for publisher",
        booksUploads: 100,
        booksFulfillments: 1000,
        price: "100",
      },
      {
        id: 10,
        version: 0,
        productId: "prod_LNucm3fIGHqyPE",
        priceId: "price_1Kh8n9Gf5lNQlEFWdiApknDQ",
        name: "Premium package",
        description: "Premium Package for publisher",
        booksUploads: 100,
        booksFulfillments: 1000,
        price: "100.99",
      },
    ],
  };
  return res.data;
};

export const getAllProducts = async () => {
  const data = JSON.parse(
    window.sessionStorage.getItem("publisherSubscriptionInfo")
  );
  const res = await axiosInstance.post("/api/subscriptions", data, {
    withCredentials: true,
  });
  return res.data;
};

export const stripeCheckout = async (data) => {
  if (data.parametersMap.mode === "CREATE") {
    const res = await axiosInstance.post("/stripe/subscription/create", data, {
      withCredentials: true,
    });
    window.location.href = res.data;
  } else {
    const res = await axiosInstance.post("/stripe/subscription/update", data, {
      withCredentials: true,
    });
    window.location.href = res.data;
  }
};

export const stripeCheckoutSubscription = async (data) => {
  const res = await axiosInstance.post("/stripe/subscription/buy", data, {
    withCredentials: true,
  });
  window.location.href = res.data;
};

export const stripeCheckoutProduct = async (data) => {
  const res = await axiosInstance.post("/stripe/product", data, {
    withCredentials: true,
  });
  window.location.href = res.data;
};

export const stripeInvoiceProduct = async (data) => {
  const res = await axiosInstance.post("/stripe/invoice", data, {
    withCredentials: true,
  });
  window.open(res.data, "_blank");
  // window.location.href = res.data;
};

export const stripeUpgradeSubscription = async (data) => {
  try {
    const res = await axiosInstance.post("/stripe/upgrade/subscription", data, {
      withCredentials: true,
    });
    window.open(res.data, "_blank");
    return { redirect: "ok" };
  } catch (e) {
    console.error(e);
    return e;
  }
};
